// extracted by mini-css-extract-plugin
export default {"pair":"MatchPair_pair__Nqwjv"};